// src/App.jsx
import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { loadAuth, clearAuth } from "./auth"; // 👈 quité saveAuth
import LoginSignup from "./Login";            // asegúrate que el nombre del archivo coincide
import PersonasPage from "./PersonasPage";
import ForgotPassword from "./ForgotPassword";
import ChangePassword from "./ChangePassword";

export default function App() {
  // Lee la sesión desde el primer render (evita flicker)
  const [user, setUser] = useState(() => {
    const auth = loadAuth();
    return auth?.user ?? null;
  });

  // Si quisieras “rehidratar” (no necesario con lo de arriba):
  // useEffect(() => {
  //   const auth = loadAuth();
  //   if (auth?.user) setUser(auth.user);
  // }, []);

  const handleLogout = () => {
    clearAuth();
    setUser(null);
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            user ? (
              <Navigate to="/personas" replace />
            ) : (
              <LoginSignup
                onAuthed={(u) => {
                  setUser(u); // el Login ya hace navigate("/personas")
                }}
              />
            )
          }
        />
        <Route
          path="/personas"
          element={
            user ? (
              <PersonasPage onLogout={handleLogout} />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/forgot-password"
          element={<ForgotPassword />}
        />
        <Route
          path="/change-password"
          element={
            user ? (
              <ChangePassword />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
